import { FC } from 'react'
import { getPlayed } from '../controllers/stats'
import DidYouKnow from './DidYouKnow'
import FeedbackBox from './FeedbackBox'

type Props = {
	openModal(modalName: string): void
}

const PostGameMessage: FC<Props> = ({ openModal }) => {
	const played = getPlayed()

	if (played === 1) {
		return <DidYouKnow openModal={openModal} />
	}

	if (played === 2 || played === 30 || played === 100) {
		return <FeedbackBox milestone={played} />
	}

	return null
}

export default PostGameMessage
